import React from "react";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import classnames from 'classnames';
import moment from 'moment-timezone';
import { Button } from 'react-bootstrap';
import { InputFeedback } from './RegistrationFormInputs';
import { getPrepLessonLocation } from '../../utils/appointmentUtils';

export const drivingSchool = [
    { label: "I attended Parkway Driving School", value: "Parkway Driving School" },
    { label: "I attended a different driving school", value: "Other Driving School" },
    { label: "I did not attend a driving school", value: "No Driving School" }
];

export const sourceOptions = [
    { value: 'Word of Mouth', label: 'Word of Mouth' },
    { value: 'Google', label: 'Google' },
    { value: 'Google Ad', label: 'Google Ad' },
    { value: 'Facebook Ad', label: 'Facebook Ad' },
    { value: 'Instagram Ad', label: 'Instagram Ad' },
    { value: 'Parkway Reminder Email', label: 'Parkway Reminder Email' },
    { value: 'Other', label: 'Other' }
];

// Radio input
export class RadioButtonDateLocation extends React.Component {
    handleChange = () => {
        this.props.form.setFieldValue("location", this.props.location, false);
        this.props.form.setFieldValue("roadTestDateOption", this.props.date, false);
        this.props.form.setFieldValue("fullRoadTestDateOption", this.props.id, false);
        this.props.form.setFieldValue("lessonDate", "", false);
        this.props.form.setFieldValue("lessonDateSlot", "", false);
        this.props.form.setFieldValue("selectedLessonChoices", [], false);

        const isWeekday = moment(this.props.date).day() !== 6;
        const currentPackage = this.props.form.values.roadTestPackage;
        if (currentPackage) {
            const packageIsWeekday = currentPackage.includes("Weekday");
            if (isWeekday !== packageIsWeekday) {
                this.props.form.setFieldValue("roadTestPackage", "", false);
                this.props.form.setFieldValue("lessonsNeeded", 0, false);
            }
        }
    };
    render() {
        return (
            <div>
                <input
                    name={this.props.name}
                    id={this.props.id}
                    type="radio"
                    value={this.props.id} // could be something else for output?
                    checked={this.props.id === this.props.form.values.fullRoadTestDateOption}
                    onChange={this.handleChange}
                    onBlur={this.props.onBlur}
                    className={classnames("radio-button")}
                />
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}

// Radio input
export class DrivingSchoolRadioButtonChoice extends React.Component {
    handleChange = value => {
        if (value !== "Other Driving School") {
            this.props.onChange("drivingSchool", value);
        }
        else {
            this.props.onChange("drivingSchool", "");
        }
        this.props.onChange("drivingSchoolChoice", value);
    };
    handleBlur = () => {
        this.props.onBlur(this.props.id, true);
    };

    render() {
        return (
            <div>
                <input
                    name={this.props.name}
                    id={this.props.id}
                    type="radio"
                    value={this.props.id} // could be something else for output?
                    checked={this.props.id === this.props.value}
                    onChange={() => this.handleChange(this.props.id)}
                    onBlur={this.handleBlur}
                    className={classnames("radio-button")}
                />
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}

// Lesson Display and Removal
export class RoadTestLessonDisplayButton extends React.Component {
    clearLesson = (date, slot) => {
        let selectedLessonChoices = this.props.values;
        selectedLessonChoices = selectedLessonChoices.filter(x => !(x.date === date && x.slot === slot));
        this.props.onChange("selectedLessonChoices", selectedLessonChoices);
    };
    handleBlur = () => {
        this.props.onBlur(this.props.id, true);
    };
    render() {
        return (
            <div className={'lessonTimes'}>
                {this.props.label}
                <Button variant="danger" size="sm" onClick={() => this.clearLesson(this.props.selectedLesson.date, this.props.selectedLesson.slot)}>X</Button>
            </div>
        );
    }
}

// Radio input for Road Lessons
export class RoadTestRadioButtonChoice extends React.Component {
    handleLessonChange = value => {
        this.props.onChange("roadTestPackage", value);
        this.props.onChange("lessonsNeeded", parseInt(this.props.package.lessons));
    };
    handleBlur = () => {
        this.props.onBlur(this.props.id, true);
    };
    render() {
        return (
            <div>
                <input
                    name={this.props.name}
                    id={this.props.id}
                    type="radio"
                    value={this.props.id}
                    checked={this.props.id === this.props.value}
                    onChange={() => this.handleLessonChange(this.props.id)}
                    className={classnames("radio-button")}
                />
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}

export class FormikSelect extends React.Component {
    handleChange = value => {
        // this is going to call setFieldValue and manually update values.
        if (value.label !== "Other") {
            this.props.onChange("sourceText", value.label);
        }
        else {
            this.props.onChange("sourceText", "");
        }
        this.props.onChange(this.props.id, value);
    };

    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched
        this.props.onBlur(this.props.id, true);
    };

    render() {
        return (
            <div style={{ margin: "1rem 0" }}>
                <label htmlFor="color">How did you hear about us?</label>
                <Select
                    id="color"
                    options={this.props.options}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={Object.entries(this.props.value).length === 0 && this.props.value.constructor === Object ? null : this.props.value}
                />
                {this.props.touched && <InputFeedback error={this.props.error && this.props.error.value} />}
            </div>
        );
    }
}


export class FormikSelectRoadLessonDate extends React.Component {

    handleChange = value => {
        this.props.onChange(this.props.id, value.value);
        let allLessonData = this.props.fetchedLessons;
        console.log(allLessonData);
        if (allLessonData[value.value]) {
            this.props.onChange("selectedDayLessonOptions", allLessonData[value.value].sort((a, b) => (a.startTime > b.startTime) ? 1 : -1).map(x => ({ "value": x.timeSlot, "label": x.timeSlot + " at " + x.location, "location": x.location })));
        }
    };

    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched
        this.props.onBlur(this.props.id, true);
    };
    loadOptions = (inputValue, callback) => {
        let that = this;
        let roadTestDate = this.props.selectedDay.substring(0, 10);
        fetch('https://x4g3mwhate.execute-api.us-east-1.amazonaws.com/dev/getpubliclessondates', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'post',
            body: JSON.stringify({ "start": roadTestDate, "location": getPrepLessonLocation(this.props.location) }
            )
        }).then(function (response) {
                return response.json();
            }).then(function (data) {
                let roadTestLessonDates = Object.keys(data)
                    .filter(date => moment(date).isBefore(moment(roadTestDate)))
                    .map(x => ({ "value": x, "label": moment(x).format('MM/DD/YYYY (dddd)') }));
                that.props.onChange("fetchedLessons", data);
                callback(roadTestLessonDates);
            });
    };

    render() {
        let roadTestDate = this.props.selectedDay.substring(0, 10);

        return (
            <div style={{ margin: "1rem 0" }}>
                <AsyncSelect
                    key={roadTestDate + this.props.location}
                    cacheOptions={false}
                    loadOptions={this.loadOptions}
                    defaultOptions
                    noOptionsMessage={() => "No lessons avaliable for " + roadTestDate + "."}
                    onChange={this.handleChange}
                />
                {this.props.touched && <InputFeedback error={this.props.error && this.props.error.value} />}
            </div>
        );
    }
}

export class FormikAddLesson extends React.Component {
    handleChange = (date, slot) => {
        let lesson = {
            "date": date,
            "slot": slot.value,
            "location": slot.location
        };

        const selectedLessonChoices = this.props.selectedLessonChoices;

        const matchedLessonChoices = selectedLessonChoices.filter(x => x.date === date && x.slot === slot.value);

        if (matchedLessonChoices.length === 0) {
            this.props.onChange("selectedLessonChoices", [...selectedLessonChoices, lesson]);
        }
    };

    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched
        this.props.onBlur(this.props.id, true);
    };

    render() {
        return (
            <button type="button" onClick={() => this.handleChange(this.props.lessonDate, this.props.lessonDateSlot)}>
                Add Lesson
            </button>
        );
    }
}

export class FormikSelectRoadLessonDateSlot extends React.Component {
    handleChange = value => {
        this.props.onChange(this.props.id, value);
    };

    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched
        this.props.onBlur(this.props.id, true);
    };
    loadOptions = (inputValue, callback) => {
        callback(this.props.selectedDayLessonOptions);
    };

    render() {
        let roadTestDate = this.props.selectedDay.substring(0, 10);
        return (
            <div style={{ margin: "1rem 0" }}>
                <AsyncSelect
                    key={"slots" + roadTestDate}
                    cacheOptions={false}
                    loadOptions={this.loadOptions}
                    defaultOptions
                    onChange={this.handleChange}
                />
                {this.props.touched && <InputFeedback error={this.props.error && this.props.error.value} />}
            </div>
        );
    }
}
